<template>
  <section id="products" class="product-section">
    <div class="container">
      <!-- <div class="section-header">
        <h2>{{ locale === 'zh' ? '产品展示' : 'Products' }}</h2>
        <p>{{ locale === 'zh' ? '查看我们的精选产品' : 'Explore our featured products' }}</p>
      </div> -->

      <!-- 分类筛选器 -->
      <div v-if="categories.length > 0" class="category-filter">
        <button 
          :class="['category-btn', { active: selectedCategory === '' }]"
          @click="selectCategory('')"
        >
          {{ locale === 'zh' ? '全部' : 'All' }}
        </button>
        <button 
          v-for="cat in categories" 
          :key="cat.id"
          :class="['category-btn', { active: selectedCategory === cat.nameZh || selectedCategory === cat.nameEn }]"
          @click="selectCategory(locale === 'zh' ? cat.nameZh : cat.nameEn)"
        >
          {{ locale === 'zh' ? cat.nameZh : cat.nameEn }}
        </button>
      </div>

      <!-- 当前选中分类提示 -->
      <div v-if="selectedCategory" class="current-category">
        <span class="category-label">
          {{ locale === 'zh' ? '当前分类：' : 'Current Category:' }}
        </span>
        <strong>{{ selectedCategory }}</strong>
        <button class="clear-filter" @click="selectCategory('')" :title="locale === 'zh' ? '清除筛选' : 'Clear filter'">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </div>

      <div v-if="loading" class="loading">
        <div class="spinner"></div>
        <p>{{ $t('common.loading') }}</p>
      </div>

      <div v-else-if="error" class="error">
        <p>{{ $t('common.error') }}</p>
        <button @click="fetchData" class="btn btn-secondary">
          {{ locale === 'zh' ? '重试' : 'Retry' }}
        </button>
      </div>

      <div v-else class="products-grid">
        <ProductCard
          v-for="product in filteredProducts"
          :key="product.id"
          :product="product"
          :locale="$i18n.locale"
        />
      </div>

      <div v-if="!loading && filteredProducts.length === 0" class="empty-state">
        <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 001.5-1.5V6a1.5 1.5 0 00-1.5-1.5H3.75A1.5 1.5 0 002.25 6v12a1.5 1.5 0 001.5 1.5zm10.5-11.25h.008v.008h-.008V8.25zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"/>
        </svg>
        <h3>{{ locale === 'zh' ? '暂无产品' : 'No Products' }}</h3>
        <p>{{ selectedCategory ? (locale === 'zh' ? '该分类下暂无产品，请选择其他分类' : 'No products in this category, please select another') : (locale === 'zh' ? '暂无产品数据' : 'No product data available') }}</p>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios'
import ProductCard from './ProductCard.vue'

export default {
  name: 'ProductSection',
  components: {
    ProductCard
  },
  data() {
    return {
      products: [],
      categories: [],
      selectedCategory: '',
      loading: true,
      error: null
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale
    },
    filteredProducts() {
      if (!this.selectedCategory) {
        return this.products
      }
      
      // 找到选中的分类对象，获取对应的中英文名称
      const matchedCategory = this.categories.find(cat =>
        cat.nameZh === this.selectedCategory || cat.nameEn === this.selectedCategory
      )

      return this.products.filter(product => {
        const productCategory = product.category || ''
        // 同时匹配中文名和英文名
        if (matchedCategory) {
          return productCategory === matchedCategory.nameZh || productCategory === matchedCategory.nameEn
        }
        // 如果没找到分类对象，直接按名称匹配
        return productCategory.toLowerCase() === this.selectedCategory.toLowerCase()
      })
    }
  },
  mounted() {
    this.fetchData()
  },
  watch: {
    locale() {
      // 语言切换时，重新匹配当前选中分类在新语言下的名称
      if (this.selectedCategory) {
        const matchedCat = this.categories.find(cat =>
          cat.nameZh === this.selectedCategory || cat.nameEn === this.selectedCategory
        )
        if (matchedCat) {
          this.selectedCategory = this.locale === 'zh' ? matchedCat.nameZh : matchedCat.nameEn
        }
      }
    }
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true
        this.error = null
        
        const [productsRes, categoriesRes] = await Promise.all([
          axios.get('/api/products/active'),
          axios.get('/api/categories/active')
        ])
        
        this.products = productsRes.data
        this.categories = categoriesRes.data
      } catch (err) {
        console.error('Error fetching data:', err)
        this.error = err.message
      } finally {
        this.loading = false
      }
    },

    selectCategory(categoryName) {
      this.selectedCategory = categoryName
    }
  }
}
</script>

<style scoped>
.product-section {
  padding: 5rem 0;
  background: var(--bg-secondary, #f8fafc);
}

/* 分类筛选器样式 */
.category-filter {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 2.5rem;
  padding: 1rem;
  background: var(--bg-secondary, #f8fafc);
  border-radius: var(--radius-md, 0.5rem);
  border: 1px solid var(--border-color, #e2e8f0);
}

.category-btn {
  padding: 0.5rem 1rem;
  background: transparent;
  color: var(--text-secondary, #64748b);
  border: 1px solid transparent;
  border-radius: var(--radius-md, 0.5rem);
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.category-btn:hover {
  color: var(--primary-color, #1a56db);
  background: var(--bg-primary, #ffffff);
  border-color: var(--border-color, #e2e8f0);
}

.category-btn.active {
  color: var(--primary-color, #1a56db);
  background: rgba(26, 86, 219, 0.06);
  border-color: rgba(26, 86, 219, 0.15);
  font-weight: 600;
}

/* 当前分类提示 */
.current-category {
  text-align: center;
  margin-bottom: 2rem;
  padding: 0.75rem 1.25rem;
  background: var(--bg-secondary, #f8fafc);
  border-radius: var(--radius-md, 0.5rem);
  border: 1px solid var(--border-color, #e2e8f0);
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin-left: auto;
  margin-right: auto;
  font-size: 0.9rem;
  color: var(--text-secondary, #64748b);
}

.current-category .category-label {
  color: var(--text-secondary);
  font-size: 0.95rem;
}

.current-category strong {
  color: var(--primary-dark);
  font-size: 1.05rem;
}

.clear-filter {
  background: none;
  border: none;
  color: var(--danger-color);
  cursor: pointer;
  font-size: 1.125rem;
  padding: 0.25rem 0.5rem;
  border-radius: var(--radius-sm);
  transition: all 0.3s ease;
  line-height: 1;
}

.clear-filter:hover {
  background: rgba(220, 38, 38, 0.1);
  transform: scale(1.1);
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 2rem;
}

@media (max-width: 768px) {
  .category-filter {
    gap: 0.5rem;
    padding: 1rem;
  }

  .category-btn {
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
  }

  .current-category {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 640px) {
  .products-grid {
    grid-template-columns: 1fr;
  }

  .product-section {
    padding: 3rem 0;
  }

  .category-filter {
    justify-content: flex-start;
    overflow-x: auto;
    flex-wrap: nowrap;
    -webkit-overflow-scrolling: touch;
  }

  .category-btn {
    flex-shrink: 0;
  }
}

.loading,
.error,
.empty-state {
  text-align: center;
  padding: 4rem 2rem;
  color: var(--text-secondary);
}

.empty-state svg {
  width: 80px;
  height: 80px;
  margin-bottom: 1rem;
  opacity: 0.5;
}

.empty-state h3 {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  color: var(--text-primary);
}

.spinner {
  width: 48px;
  height: 48px;
  border: 4px solid var(--border-color);
  border-top-color: var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1.5rem;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.error button {
  margin-top: 1rem;
}
</style>